if (!customElements.get('kion-sound-player')) {
  customElements.define(
    'kion-sound-player',
    class KionSoundPlayer extends HTMLElement {
      connectedCallback() {
        this.audio = new Audio();
        this.audio.preload = 'none';
        this.current = null;

        // The ripple animation is driven by the audio element's own
        // playback state, not by tap timing or a guess-timer:
        // - 'playing' fires only once audio is actually producing sound
        //   (after any buffering), so the ripple never starts early.
        // - 'pause' fires for both user-initiated and external pauses
        //   (e.g. OS/lock-screen media controls), so the ripple always
        //   stops in sync with real playback, not just our own UI calls.
        // - 'ended' already resets full button state via reset().
        this.audio.addEventListener('playing', () => {
          if (this.current) this.current.classList.add('is-playing');
        });
        this.audio.addEventListener('pause', () => this.clearPlayingVisual());
        this.audio.addEventListener('ended', () => this.reset());

        this.addEventListener('click', (event) => {
          const button = event.target.closest('.kion-sound__button');
          if (!button) return;
          this.toggle(button);
        });
      }

      disconnectedCallback() {
        if (this.audio) this.audio.pause();
      }

      toggle(button) {
        if (this.current === button) {
          this.audio.pause();
          this.reset();
          return;
        }

        this.reset();
        this.current = button;
        button.setAttribute('aria-pressed', 'true');
        this.audio.src = button.dataset.src;
        this.audio.play().catch(() => this.reset());
      }

      reset() {
        if (this.current) this.current.setAttribute('aria-pressed', 'false');
        this.current = null;
        this.clearPlayingVisual();
      }

      clearPlayingVisual() {
        const active = this.querySelector('.kion-sound__button.is-playing');
        if (active) active.classList.remove('is-playing');
      }
    }
  );
}
